import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { ArrowBack } from '@mui/icons-material'
import { Button, Stack, Typography } from '@mui/material'

import { GameIcon } from '../../../../../features/game'
import { InternalAnalysis } from '../../../analysis/types/InternalAnalysis'
import { InternalGameDocument } from '../../../games/types/InternalGame'

type ScreenshotsHeaderProps = {
  title?: string
  analysis: InternalAnalysis
  game: InternalGameDocument
  backLabel: string
  onBack: () => void
  detail?: ReactNode
  actions?: ReactNode
}

export const ScreenshotsHeader: FC<ScreenshotsHeaderProps> = ({ title, analysis, game, backLabel, onBack, detail, actions }) => {
  const { t } = useTranslation()

  return (
    <Stack spacing={2} mb={3}>
      <Stack direction="row" alignItems="center" spacing={2} flexWrap="wrap" useFlexGap>
        <Button size="small" startIcon={<ArrowBack />} onClick={onBack}>
          {backLabel}
        </Button>
        {title && (
          <Typography variant="h5" fontWeight="bold">
            {title}
          </Typography>
        )}
        <Stack direction="row" spacing={1} ml="auto" flexWrap="wrap" useFlexGap>
          {actions}
        </Stack>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center">
        <GameIcon src={game.icons?.length ? game.icons : game.icon ?? undefined} gameName={game.name ?? ''} size="small" />
        <Stack spacing={0.25} minWidth={0}>
          <Typography fontWeight="bold">
            {game.name}{' '}
            <Typography component="span" color="text.secondary" textTransform="uppercase">
              ({analysis.marketIso})
            </Typography>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {[game.artist || '---', analysis.gameVersion ? t('internal-analysts:analysis_screenshots_version', { version: analysis.gameVersion }) : undefined]
              .filter(Boolean)
              .join(' · ')}
          </Typography>
          {detail && <Typography variant="body2">{detail}</Typography>}
        </Stack>
      </Stack>
    </Stack>
  )
}
